import { render, staticRenderFns } from "./TeacherSms.vue?vue&type=template&id=a0a2c132&"
import script from "./TeacherSms.vue?vue&type=script&lang=js&"
export * from "./TeacherSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports